/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Aggregation } from './Aggregation';
import {
    AggregationFromJSON,
    AggregationFromJSONTyped,
    AggregationToJSON,
    AggregationToJSONTyped,
} from './Aggregation';
import type { ResourceType } from './ResourceType';
import {
    ResourceTypeFromJSON,
    ResourceTypeFromJSONTyped,
    ResourceTypeToJSON,
    ResourceTypeToJSONTyped,
} from './ResourceType';
import type { HistoricMeanSpan } from './HistoricMeanSpan';
import {
    HistoricMeanSpanFromJSON,
    HistoricMeanSpanFromJSONTyped,
    HistoricMeanSpanToJSON,
    HistoricMeanSpanToJSONTyped,
} from './HistoricMeanSpan';
import type { AnonRequestFilter } from './AnonRequestFilter';
import {
    AnonRequestFilterFromJSON,
    AnonRequestFilterFromJSONTyped,
    AnonRequestFilterToJSON,
    AnonRequestFilterToJSONTyped,
} from './AnonRequestFilter';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface DataRequestResource
 */
export interface DataRequestResource {
    /**
     * 
     * @type {string}
     * @memberof DataRequestResource
     */
    metricKey: string;
    /**
     * 
     * @type {string}
     * @memberof DataRequestResource
     */
    name: string;
    /**
     * 
     * @type {Aggregation}
     * @memberof DataRequestResource
     */
    timeAggregation: Aggregation;
    /**
     * 
     * @type {Aggregation}
     * @memberof DataRequestResource
     */
    generatorAggregation: Aggregation;
    /**
     * 
     * @type {number}
     * @memberof DataRequestResource
     */
    dataLimit?: number;
    /**
     * 
     * @type {ResourceType}
     * @memberof DataRequestResource
     */
    resourceType: ResourceType;
    /**
     * 
     * @type {string}
     * @memberof DataRequestResource
     */
    resourceKey?: string;
    /**
     * 
     * @type {string}
     * @memberof DataRequestResource
     */
    portfolioKey: string;
    /**
     * 
     * @type {Array<AnonRequestFilter>}
     * @memberof DataRequestResource
     */
    filter?: Array<AnonRequestFilter>;
    /**
     * 
     * @type {number}
     * @memberof DataRequestResource
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof DataRequestResource
     */
    timeTo: number;
    /**
     * 
     * @type {Resolution}
     * @memberof DataRequestResource
     */
    resolution?: Resolution;
    /**
     * 
     * @type {HistoricMeanSpan}
     * @memberof DataRequestResource
     */
    historicMeanSpan?: HistoricMeanSpan;
}



/**
 * Check if a given object implements the DataRequestResource interface.
 */
export function instanceOfDataRequestResource(value: object): value is DataRequestResource {
    if (!('metricKey' in value) || value['metricKey'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('timeAggregation' in value) || value['timeAggregation'] === undefined) return false;
    if (!('generatorAggregation' in value) || value['generatorAggregation'] === undefined) return false;
    if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    return true;
}

export function DataRequestResourceFromJSON(json: any): DataRequestResource {
    return DataRequestResourceFromJSONTyped(json, false);
}

export function DataRequestResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataRequestResource {
    if (json == null) {
        return json;
    }
    return {
        
        'metricKey': json['metricKey'],
        'name': json['name'],
        'timeAggregation': AggregationFromJSON(json['timeAggregation']),
        'generatorAggregation': AggregationFromJSON(json['generatorAggregation']),
        'dataLimit': json['dataLimit'] == null ? undefined : json['dataLimit'],
        'resourceType': ResourceTypeFromJSON(json['resourceType']),
        'resourceKey': json['resourceKey'] == null ? undefined : json['resourceKey'],
        'portfolioKey': json['portfolioKey'],
        'filter': json['filter'] == null ? undefined : ((json['filter'] as Array<any>).map(AnonRequestFilterFromJSON)),
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'resolution': json['resolution'] == null ? undefined : ResolutionFromJSON(json['resolution']),
        'historicMeanSpan': json['historicMeanSpan'] == null ? undefined : HistoricMeanSpanFromJSON(json['historicMeanSpan']),
    };
}

export function DataRequestResourceToJSON(json: any): DataRequestResource {
    return DataRequestResourceToJSONTyped(json, false);
}

export function DataRequestResourceToJSONTyped(value?: DataRequestResource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metricKey': value['metricKey'],
        'name': value['name'],
        'timeAggregation': AggregationToJSON(value['timeAggregation']),
        'generatorAggregation': AggregationToJSON(value['generatorAggregation']),
        'dataLimit': value['dataLimit'],
        'resourceType': ResourceTypeToJSON(value['resourceType']),
        'resourceKey': value['resourceKey'],
        'portfolioKey': value['portfolioKey'],
        'filter': value['filter'] == null ? undefined : ((value['filter'] as Array<any>).map(AnonRequestFilterToJSON)),
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'resolution': ResolutionToJSON(value['resolution']),
        'historicMeanSpan': HistoricMeanSpanToJSON(value['historicMeanSpan']),
    };
}

